import { MenuItemsType } from '../types/menuTypes';

export const getMenuItemIndex = (menuItems: MenuItemsType, url: string) =>
  menuItems?.findIndex((routeInfo) =>
    routeInfo.highlightLocations.some((routeName) => url.includes(routeName))
  );
